import getGraphQlClient from '~graphql/getGraphQlClient';
import { updateEditorCanvas } from '~graphql/controllers';
import {
  DELETE_TEMPLATE_DEFAULT_PAGE,
  DELETE_TEMPLATE_PAGE,
  REMOVE_TEMPLATE_DEFAULT_PAGE,
  REMOVE_TEMPLATE_PAGE,
} from '~graphql/queries/modifyTemplate';
import {
  EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER,
  EDITOR_MODE_ORG_TEMPLATE_MANAGER,
} from '~config/editorConstants';
import { getState } from '~src/state';

const deleteTemplatePage = async (templateId, pageId, isGlobal) => {
  if (!templateId) {
    throw new Error('Missing template id');
  }

  const graphQlClient = await getGraphQlClient();

  await graphQlClient.mutate({
    mutation: isGlobal ? REMOVE_TEMPLATE_DEFAULT_PAGE : REMOVE_TEMPLATE_PAGE,
    variables: { id: templateId, pageId },
  });

  // Le pagine dei modelli hanno anche il pointer al modello: staccarle dalla
  // relation non basta, le letture per pointer continuerebbero a vederle.
  await graphQlClient.mutate({
    mutation: isGlobal ? DELETE_TEMPLATE_DEFAULT_PAGE : DELETE_TEMPLATE_PAGE,
    variables: { id: pageId },
  });
};

export const deleteEditorPage = async (pageId) => {
  // Pagina aggiunta in questa sessione e mai salvata: lato server non esiste.
  if (!pageId) return;

  const editorMode = getState('editorMode');

  if (
    [
      EDITOR_MODE_ORG_TEMPLATE_MANAGER,
      EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER,
    ].includes(editorMode)
  ) {
    await deleteTemplatePage(
      window.editorLoader.templateId,
      pageId,
      editorMode === EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER
    );
    return;
  }

  const { canvasId } = window.editorLoader;

  if (!canvasId) {
    throw new Error('Missing canvas id');
  }

  await updateEditorCanvas(canvasId, {
    editor_canvas_pages: {
      remove: [pageId],
    },
  });
};
